/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import { ReduxUtils } from '@spm/core';

import { FETCH_SD_GET_ACCESS_TOKEN } from './actionTypes';

import { fetchSdGetAccessTokenUtil } from './utils';

/**
 * Contains the action creator functions that update the ExternalUserAccessToken slice of the store.
 *
 * @namespace ExternalUserAccessTokenActions
 */
export default class actions {
  /**
   * Calls the api and dispatches the results to the store.
   * api: /v1/sd_get_access_token
   *
   * @param {string} userName.
   * @param {any} callback function to call once this function has finished
   * @function
   * @memberof ExternalUserAccessTokenActions
   */
  static fetchSdGetAccessToken = (dispatch, userName, callback) => {
    ReduxUtils.generateAction(
      dispatch,
      fetchSdGetAccessTokenUtil.bind(null, userName),

      FETCH_SD_GET_ACCESS_TOKEN,
      callback
    );
  };

  /**
   * Dispatches the data to the store to reset the data cached from a call to fetchSdGetAccessToken.
   *
   * @param {function} dispatch
   * @param {Object} data object to be set in the store.
   * @function
   * @memberof ExternalUserAccessTokenActions
   */
  static resetFetchSdGetAccessToken = (dispatch, data) => {
    const json = {
      type: FETCH_SD_GET_ACCESS_TOKEN.successAction,
      payload: data,
    };
    dispatch(json);
  };

  /**
   * Dispatches the data to the store to reset the error cached from a call to fetchSdGetAccessToken.
   *
   * @param {function} dispatch
   * @function
   * @memberof ExternalUserAccessTokenActions
   */
  static resetFetchSdGetAccessTokenError = dispatch => {
    ReduxUtils.resetErrorAction(dispatch, FETCH_SD_GET_ACCESS_TOKEN.failureAction);
  };
}
